import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { VideoIcon, SendIcon, ZapIcon, MessageSquareIcon, CheckIcon, SettingsIcon, RocketIcon, ArrowRightLeftIcon } from 'lucide-react';
const steps = [{
  id: 'record',
  icon: <VideoIcon className="w-5 h-5" data-id="element-101" />,
  title: 'Share your workflow',
  description: 'Show us how your team handles enrollments and quoting today. Our AI and automation systems quickly learn your exact steps and business rules.'
}, {
  id: 'choose',
  icon: <ArrowRightLeftIcon className="w-5 h-5" data-id="element-102" />,
  title: 'We tailor our approach',
  description: 'Stay hands-on or let our dedicated team handle everything. We adapt to your preferred level of involvement.'
}, {
  id: 'assign',
  icon: <SendIcon className="w-5 h-5" data-id="element-103" />,
  title: 'Hand off enrollment tasks',
  description: 'Upload a spreadsheet or send enrollments our way — whatever is easiest for your team.'
}, {
  id: 'audit',
  icon: <MessageSquareIcon className="w-5 h-5" data-id="element-104" />,
  title: 'Ongoing collaboration',
  description: 'Share feedback and our operations professionals are always on it. We learn your preferences over time.'
}, {
  id: 'notify',
  icon: <ZapIcon className="w-5 h-5" data-id="element-105" />,
  title: 'Complete visibility',
  description: 'If a tricky situation arises, our experts step in to finish the job. You get notified every step of the way.'
}];
function Step1Visual() {
  const videoRef = useRef(null);
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 2.0;
    }
  }, []);
  return <div className="w-full rounded-xl overflow-hidden shadow-xl border border-gray-300 flex bg-white" data-id="element-106">
      <video ref={videoRef} src="https://cdn.magicpatterns.com/uploads/ku3JurpmEHEXMEyDefSUH3/cursorful-video-1774807784388.mp4" autoPlay loop muted playsInline className="w-full h-auto block" data-id="element-107" />
    </div>;
}
function Step2Visual() {
  const videoRef = useRef(null);
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 2.0;
    }
  }, []);
  return <div className="w-full rounded-xl overflow-hidden shadow-xl border border-gray-300 flex bg-white" data-id="element-108">
      <video ref={videoRef} src="https://cdn.magicpatterns.com/uploads/hfG3U5JtyoQp87f7HxYNqf/demo asset 1.mp4" autoPlay loop muted playsInline className="w-full h-auto block" data-id="element-109" />
    </div>;
}
function Step2ChoiceVisual() {
  const videoRef = useRef(null);
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 2.0;
    }
  }, []);
  return <div className="w-full rounded-xl overflow-hidden shadow-xl border border-gray-200 flex bg-white" data-id="element-110">
      <video ref={videoRef} src="https://cdn.magicpatterns.com/uploads/dxGx5frAxgD1YExx9wwjki/cursorful-video-1774811775195.mp4" autoPlay loop muted playsInline className="w-full h-auto block" data-id="element-111" />
    </div>;
}
function Step4Visual() {
  return <div className="w-full h-[400px] lg:h-[500px] rounded-xl border border-gray-300 shadow-xl overflow-hidden flex" data-id="element-112">
      {/* Slack Sidebar */}
      <div className="w-[180px] shrink-0 flex flex-col" style={{
      backgroundColor: '#3F0E40'
    }} data-id="element-113">
        {/* Workspace header */}
        <div className="px-4 py-3 border-b border-white/10" data-id="element-114">
          <div className="flex items-center gap-2" data-id="element-115">
            {/* Slack-style logo */}
            <svg width="18" height="18" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-116">
              <path d="M19.712.133a5.381 5.381 0 0 0-5.376 5.387 5.381 5.381 0 0 0 5.376 5.386h5.376V5.52A5.381 5.381 0 0 0 19.712.133m0 14.365H5.376A5.381 5.381 0 0 0 0 19.884a5.381 5.381 0 0 0 5.376 5.387h14.336a5.381 5.381 0 0 0 5.376-5.387 5.381 5.381 0 0 0-5.376-5.386" fill="#36C5F0" data-id="element-117" />
              <path d="M53.76 19.884a5.381 5.381 0 0 0-5.376-5.386 5.381 5.381 0 0 0-5.376 5.386v5.387h5.376a5.381 5.381 0 0 0 5.376-5.387m-14.336 0V5.52A5.381 5.381 0 0 0 34.048.133a5.381 5.381 0 0 0-5.376 5.387v14.364a5.381 5.381 0 0 0 5.376 5.387 5.381 5.381 0 0 0 5.376-5.387" fill="#2EB67D" data-id="element-118" />
              <path d="M34.048 54a5.381 5.381 0 0 0 5.376-5.387 5.381 5.381 0 0 0-5.376-5.386h-5.376v5.386A5.381 5.381 0 0 0 34.048 54m0-14.365h14.336a5.381 5.381 0 0 0 5.376-5.386 5.381 5.381 0 0 0-5.376-5.387H34.048a5.381 5.381 0 0 0-5.376 5.387 5.381 5.381 0 0 0 5.376 5.386" fill="#ECB22E" data-id="element-119" />
              <path d="M0 34.249a5.381 5.381 0 0 0 5.376 5.386 5.381 5.381 0 0 0 5.376-5.386v-5.387H5.376A5.381 5.381 0 0 0 0 34.25m14.336 0v14.364A5.381 5.381 0 0 0 19.712 54a5.381 5.381 0 0 0 5.376-5.387V34.25a5.381 5.381 0 0 0-5.376-5.387 5.381 5.381 0 0 0-5.376 5.387" fill="#E01E5A" data-id="element-120" />
            </svg>
            <span className="text-white font-bold text-sm truncate" data-id="element-121">
              Acme Company
            </span>
          </div>
        </div>

        {/* Channels */}
        <div className="flex-1 py-3 px-2 space-y-0.5 overflow-hidden" data-id="element-122">
          <div className="text-[10px] font-semibold text-white/40 uppercase tracking-wider px-2 mb-2" data-id="element-123">
            Channels
          </div>
          <div className="flex items-center gap-2 px-2 py-1.5 rounded text-white/50 text-xs" data-id="element-124">
            <span className="text-white/30" data-id="element-125">#</span>
            <span data-id="element-126">general</span>
          </div>
          <div className="flex items-center gap-2 px-2 py-1.5 rounded text-white text-xs font-medium" style={{
          backgroundColor: 'rgba(255,255,255,0.12)'
        }} data-id="element-127">
            <span className="text-white/70" data-id="element-128">#</span>
            <span data-id="element-129">bedford-tasks</span>
            <span className="ml-auto bg-red-500 text-white text-[9px] font-bold w-4 h-4 rounded-full flex items-center justify-center" data-id="element-130">
              2
            </span>
          </div>
          <div className="flex items-center gap-2 px-2 py-1.5 rounded text-white/50 text-xs" data-id="element-131">
            <span className="text-white/30" data-id="element-132">#</span>
            <span data-id="element-133">ops-team</span>
          </div>
          <div className="flex items-center gap-2 px-2 py-1.5 rounded text-white/50 text-xs" data-id="element-134">
            <span className="text-white/30" data-id="element-135">#</span>
            <span data-id="element-136">onboarding</span>
          </div>

          <div className="text-[10px] font-semibold text-white/40 uppercase tracking-wider px-2 mt-4 mb-2" data-id="element-137">
            Direct Messages
          </div>
          <div className="flex items-center gap-2 px-2 py-1.5 rounded text-white/50 text-xs" data-id="element-138">
            <div className="w-2 h-2 rounded-full bg-green-400 shrink-0" data-id="element-139" />
            <span data-id="element-140">Ariel</span>
          </div>
          <div className="flex items-center gap-2 px-2 py-1.5 rounded text-white/50 text-xs" data-id="element-141">
            <div className="w-2 h-2 rounded-full bg-white/20 shrink-0" data-id="element-142" />
            <span data-id="element-143">Sarah Chen</span>
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col bg-white" data-id="element-144">
        {/* Channel header */}
        <div className="px-5 py-3 border-b border-gray-200 flex items-center gap-2" data-id="element-145">
          <span className="font-bold text-slate-900 text-sm" data-id="element-146">
            # bedford-tasks
          </span>
          <span className="text-[11px] text-slate-900/40 border-l border-gray-300 pl-2 ml-1" data-id="element-147">
            Task execution feed
          </span>
        </div>

        {/* Messages area */}
        <div className="p-5 flex-1 overflow-y-auto space-y-6 bg-white" data-id="element-148">
          {/* Thread 1: Success */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="space-y-2" data-id="element-149">
            <div className="flex gap-3 items-start" data-id="element-150">
              <div className="w-8 h-8 rounded-lg shrink-0 flex items-center justify-center text-white text-xs font-bold bg-slate-800 shadow-sm" data-id="element-151">
                M
              </div>
              <div data-id="element-152">
                <div className="flex items-baseline gap-2 mb-0.5" data-id="element-153">
                  <span className="font-bold text-sm text-slate-900" data-id="element-154">
                    Bedford Team
                  </span>
                  <span className="text-[11px] text-slate-900/40" data-id="element-155">
                    10:01 AM
                  </span>
                </div>
                <p className="text-sm text-slate-900/80" data-id="element-156">
                  Task <strong data-id="element-157">TASK-8492</strong> is being executed.
                </p>
              </div>
            </div>

            <div className="pl-11 space-y-2 relative" data-id="element-158">
              <div className="absolute left-[22px] top-0 bottom-2 w-px bg-gray-200" data-id="element-159" />

              <motion.div initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.8
            }} className="flex gap-3 items-start relative" data-id="element-160">
                <div className="w-6 h-6 rounded-md shrink-0 flex items-center justify-center text-white text-[10px] font-bold bg-slate-800 z-10 shadow-sm" data-id="element-161">
                  M
                </div>
                <p className="text-sm text-slate-900/80 mt-0.5" data-id="element-162">
                  Processing...
                </p>
              </motion.div>

              <motion.div initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 1.4
            }} className="flex gap-3 items-start relative" data-id="element-163">
                <div className="w-6 h-6 rounded-md shrink-0 flex items-center justify-center text-white text-[10px] font-bold bg-slate-800 z-10 shadow-sm" data-id="element-164">
                  M
                </div>
                <p className="text-sm text-slate-900/80 mt-0.5 flex items-center gap-1.5" data-id="element-165">
                  <CheckIcon className="w-4 h-4 text-sage-600" data-id="element-166" />
                  <span className="text-sage-700 font-medium" data-id="element-167">
                    Successfully completed.
                  </span>{' '}
                  Task complete.
                </p>
              </motion.div>
            </div>
          </motion.div>

          {/* Divider */}
          <div className="flex items-center gap-3" data-id="element-168">
            <div className="flex-1 h-px bg-gray-200" data-id="element-169" />
            <span className="text-[10px] text-slate-900/30 font-medium" data-id="element-170">
              New messages
            </span>
            <div className="flex-1 h-px bg-gray-200" data-id="element-171" />
          </div>

          {/* Thread 2: Fail + Human */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 2.2
        }} className="space-y-2" data-id="element-172">
            <div className="flex gap-3 items-start" data-id="element-173">
              <div className="w-8 h-8 rounded-lg shrink-0 flex items-center justify-center text-white text-xs font-bold bg-slate-800 shadow-sm" data-id="element-174">
                M
              </div>
              <div data-id="element-175">
                <div className="flex items-baseline gap-2 mb-0.5" data-id="element-176">
                  <span className="font-bold text-sm text-slate-900" data-id="element-177">
                    Bedford Team
                  </span>
                  <span className="text-[11px] text-slate-900/40" data-id="element-178">
                    10:04 AM
                  </span>
                </div>
                <p className="text-sm text-slate-900/80" data-id="element-179">
                  Task <strong data-id="element-180">TASK-8493</strong> is being executed.
                </p>
              </div>
            </div>

            <div className="pl-11 space-y-2 relative" data-id="element-181">
              <div className="absolute left-[22px] top-0 bottom-6 w-px bg-gray-200" data-id="element-182" />

              <motion.div initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 2.8
            }} className="flex gap-3 items-start relative" data-id="element-183">
                <div className="w-6 h-6 rounded-md shrink-0 flex items-center justify-center text-white text-[10px] font-bold bg-slate-800 z-10 shadow-sm" data-id="element-184">
                  M
                </div>
                <p className="text-sm text-slate-900/80 mt-0.5" data-id="element-185">
                  Processing...
                </p>
              </motion.div>

              <motion.div initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 3.4
            }} className="flex gap-3 items-start relative" data-id="element-186">
                <div className="w-6 h-6 rounded-md shrink-0 flex items-center justify-center text-white text-[10px] font-bold bg-slate-800 z-10 shadow-sm" data-id="element-187">
                  M
                </div>
                <p className="text-sm text-slate-900/80 mt-0.5 flex items-center gap-1.5" data-id="element-188">
                  <span className="text-amber-600 font-medium flex items-center gap-1" data-id="element-189">
                    ⚠️ Review required.
                  </span>
                </p>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              y: 5
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 4.2
            }} className="flex gap-3 items-start relative pt-1" data-id="element-190">
                <div className="w-6 h-6 rounded-md shrink-0 flex items-center justify-center text-white text-[10px] font-bold bg-slate-700 z-10 shadow-sm mt-1" data-id="element-191">
                  D
                </div>
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 shadow-sm" data-id="element-192">
                  <div className="flex items-baseline gap-2 mb-1" data-id="element-193">
                    <span className="font-bold text-xs text-slate-900" data-id="element-194">
                      Ariel
                    </span>
                    <span className="text-[10px] text-slate-900/40" data-id="element-195">
                      10:05 AM
                    </span>
                  </div>
                  <p className="text-xs text-slate-900/80 leading-relaxed" data-id="element-196">
                    Hi team! I'm Ariel. I work at Bedford. Noticed a tricky
                    situation here, I'll be stepping in to complete the task. As
                    always you can audit the tasks we complete in the Bedford
                    dashboard.
                  </p>
                </div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
}
function Step3Visual() {
  const videoRef = useRef(null);
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 2.0;
    }
  }, []);
  return <div className="w-full rounded-xl overflow-hidden shadow-xl border border-gray-300 flex bg-white" data-id="element-197">
      <video ref={videoRef} src="https://cdn.magicpatterns.com/uploads/q44xfDiqB5NyCdnAYsAzMM/cursorful-video-1774807844820.mp4" autoPlay loop muted playsInline className="w-full h-auto block" data-id="element-198" />
    </div>;
}
const panels = [<Step1Visual key="1" data-id="element-199" />, <Step2ChoiceVisual key="2" data-id="element-200" />, <Step2Visual key="3" data-id="element-201" />, <Step3Visual key="4" data-id="element-202" />, <Step4Visual key="5" data-id="element-203" />];
export function HowItWorksSection() {
  return <section className="py-24 md:py-32 bg-gray-100" data-id="element-204">
      <div className="max-w-7xl mx-auto px-6" data-id="element-205">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-20 md:mb-32 max-w-3xl mx-auto text-center" data-id="element-206">
          <span className="text-steel-700 font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-207">
            Here's how it works
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-slate-900 leading-tight" data-id="element-208">
            We learn your workflows in less than a day & use automation to
            quickly and accurately handle manaul work for you.
          </h2>
        </motion.div>

        <div className="space-y-24 md:space-y-40" data-id="element-209">
          {steps.map((step, index) => {
          const isEven = index % 2 === 0;
          return <motion.div key={step.id} initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.7
          }} className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-20 items-center" data-id="element-210">
                {/* Text Content */}
                <div className={`flex flex-col ${isEven ? 'lg:order-1' : 'lg:order-2'}`} data-id="element-211">
                  <div className="flex items-center gap-4 mb-6" data-id="element-212">
                    <div className="w-12 h-12 rounded-xl bg-white border border-gray-200 shadow-sm text-steel-600 flex items-center justify-center shrink-0" data-id="element-213">
                      {step.icon}
                    </div>
                    <span className="text-4xl font-heading font-bold text-gray-300 select-none" data-id="element-214">
                      0{index + 1}
                    </span>
                  </div>

                  <div className="flex items-center gap-3 mb-4" data-id="element-215">
                    <h3 className="text-2xl md:text-3xl font-heading font-bold text-slate-900" data-id="element-216">
                      {step.title}
                    </h3>
                  </div>
                  <p className="text-lg text-slate-900/70 leading-relaxed" data-id="element-217">
                    {step.description}
                  </p>
                </div>

                {/* Visual Content */}
                <div className={`relative w-full ${isEven ? 'lg:order-2' : 'lg:order-1'}`} data-id="element-218">
                  {panels[index]}
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}